import { uniqBy as d } from "lodash-es";
import { getGoliathImages as o } from "@i22/rocket";
const u = (t) => {
  if (!t) return [];
  const e = [];
  "media" in t && t.media && t.media.forEach((a) => {
    a && a.remote === !1 && e.push(a);
  }), e.length === 0 && t.product && "teaserImage" in t.product && !t.product.teaserImage?.remote && e.push(t.product.teaserImage);
  const r = t?.product, n = (r && "bundledProducts" in r ? r.bundledProducts || [] : []).map((a) => a?.teaserImage), s = d(n, "path");
  return o({
    // @ts-ignore
    media: [...e, ...s]
  });
}, g = (t, e = 0) => {
  if (!t) return;
  const r = u(t);
  if (!(r.length < e + 1))
    return r[e];
};
export {
  u as getImagesFromOffer,
  g as getMainImageFromOffer
};
